import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useStepTitle } from './hooks/useStepTitle.js';
import { CenteredText } from '../common.js';
import { AnimatePresence, motion } from 'framer-motion';
import { useModalStore } from '../../stores/index.js';
import { BODY_MOTION_VARIANTS, BODY_TRANSITION } from '../../constants/constants.js';
export const Header = () => {
    const { title } = useStepTitle();
    const stepDirection = useModalStore(state => state.stepDirection);
    const currentStep = useModalStore(state => state.step);
    return (_jsx(AnimatePresence, { mode: "popLayout", initial: false, custom: stepDirection, children: _jsx(Container, { custom: stepDirection, variants: BODY_MOTION_VARIANTS, initial: "enter", animate: "center", exit: "exit", transition: BODY_TRANSITION, slot: "header", id: "header", children: _jsx(CenteredText, { weight: "semiBold", color: "secondary", children: title }) }, currentStep) }));
};
const Container = styled(motion.div) `
  position: absolute;
  top: 16px;
  width: 100%;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
`;
